const COMMON_QA_AGENTS = [
  'lauracanon@habi.co',
  'carlosbaquero@habi.co',
  'cristianpalacios@tuhabi.mx',
  'edwardmartinez@habi.co',
  'santiagosalcedo@habi.co',
] as const;

export const AGENTS_LIST_APPROVER = {
  CO: {
    QA: COMMON_QA_AGENTS,
    PROD: [
      'aprobologo1@habi.co',
      'aprobologo2@habi.co',
      'aprobologo3@habi.co',
      'aprobologo4@habi.co',
      'jeffersonbejarano@habi.co',
      'paularamirez@habi.co',
      'miguelbetanzo@tuhabi.mx',
      'rafaelacevedo@habi.co',
      'erianrincon@habi.co',
      'nicolasbolanos@habi.co',
      'davidboyaca@habi.co',
    ],
  },
  MX: {
    QA: COMMON_QA_AGENTS,
    PROD: [
      'aprobologo1@tuhabi.mx',
      'aprobologo2@tuhabi.mx',
      'aprobologo3@tuhabi.mx',
      'aprobologo4@tuhabi.mx',
      'jeffersonbejarano@habi.co',
      'paularamirez@habi.co',
      'miguelbetanzo@tuhabi.mx',
      'rafaelacevedo@habi.co',
      'erianrincon@habi.co',
      'nicolasbolanos@habi.co',
      'davidboyaca@habi.co',
    ],
  },
} as const;

const normalizeEnv = (): 'development' | 'production' => {
  const rawEnv = process.env.REACT_ENV ?? '';
  const env = rawEnv.trim().toLowerCase();
  return env === 'development' ? 'development' : 'production';
};

export const getAgentsByEnv = (country: 'MX' | 'CO'): readonly string[] => {
  if (!country || !AGENTS_LIST_APPROVER.hasOwnProperty(country)) {
    console.warn(`País no definido o no soportado: ${country}`);
    return [];
  }

  const env = normalizeEnv();
  const envKey = env === 'development' ? 'QA' : 'PROD';
  return AGENTS_LIST_APPROVER[country][envKey];
};
